@if (!needsSubmitted || vm.isLoading) {
  @if (!open()) {
    <section class="extra-support" [class.open]="vm.open">
      <button
        class="arrow-button"
        data-testid="vc-open-form"
        (click)="open.set(!open())"
        [attr.aria-expanded]="!!vm.open"
      >
        <div class="vc-title gap-8">
          <h2 class="heading-5 support-heading">Do you need extra support?</h2>
          <p class="body mt-8">Let us know if you need more support during your {{ vm.claimTypeWord }}.</p>
        </div>
        <i
          class="fa-solid fa-chevron-right fa-lg"
          style="color: #0065c4"
          [class.fa-chevron-up]="vm.open"
          [class.fa-chevron-right]="!vm.open"
        ></i>
      </button>
    </section>
  } @else {
    <section class="content">
      <section class="inner-content">
        @for (section of vulnerableCustomersForm; track section) {
          @if (section.name !== 'otherNeeds') {
            <p class="body bold">{{ section.title }}</p>
          } @else {
            <label for="text-area" class="body bold">{{ section.title }}</label>
          }
          <p class="body section-description">{{ section.description }}</p>
          <div class="checkbox-wrapper" data-testid="vc-checkbox-section">
            @for (option of section.options; track option) {
              <label class="checkbox">
                <input
                  type="checkbox"
                  [(ngModel)]="formValues[section.name][option.value]"
                  [disabled]="vm.isLoading"
                  name="{{ section.name + '_' + option.value }}"
                />
                <span class="box">
                  <svg
                    class="checkmark"
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="13"
                    viewBox="0 0 17 13"
                    fill="none"
                  >
                    <path
                      d="M14.3779 1.5957C14.921 1.07338 15.7987 1.07344 16.3418 1.5957C16.3486 1.60222 16.3535 1.61105 16.3594 1.61816C16.8863 2.14774 16.8801 2.99272 16.3389 3.51367L7.19629 12.3125C6.65317 12.8347 5.77546 12.8349 5.23242 12.3125L0.661133 7.91309C0.112572 7.38512 0.112572 6.52308 0.661133 5.99512C1.20428 5.47241 2.0828 5.47245 2.62598 5.99512L6.21582 9.44727L14.3779 1.5957Z"
                      fill="#0065C4"
                      stroke="#0065C4"
                      stroke-width="0.5"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <span class="body">{{ option.label }}</span>
              </label>
            }
          </div>
          @if (section.name !== 'otherNeeds') {
            <div class="divider mt-16 mb-16"></div>
          }
        }
        <app-text-area
          dataLabel="Please tell us anything else we should know here."
          dataTestId="should-know-textarea"
          placeHolder="Please tell us anything else we should know here."
          class="text-area"
          [(ngModel)]="formValues.otherNeeds"
          [disabled]="vm.isLoading"
          [showCount]="false"
        >
        </app-text-area>

        <div class="divider mt-20 mb-16"></div>

        <p class="body">
          This information is optional. By sharing it with us, you agree that we can use it to support you.
        </p>

        @if (formIsEmpty && submitClicked && !showWarningMessage) {
          <section class="error mt-16">
            <i class="fa-light fa-circle-exclamation"></i>
            <p class="body" data-testid="vc-initial-empty-form-error">
              Please select an option or tell us about your needs.
            </p>
          </section>
        }
        @if (!buttonsHidden) {
          <div class="button-container first-container">
            <app-button
              class="back-btn"
              dataLabel="goBack"
              (click)="open.set(false)"
              [buttonOptions]="{
                variant: 'secondary',
              }"
            >
              <i class="fa-light fa-arrow-left mr-8"></i>
              Back
            </app-button>
            <app-button
              data-testid="vc-save-and-submit"
              class="save-btn"
              dataLabel="saveAndSubmit"
              (click)="saveAndSubmit()"
              [buttonOptions]="{
                variant: 'primary',
              }"
            >
              Save and submit
            </app-button>
          </div>
        }

        @if (showWarningMessage) {
          <div class="divider mt-16 mb-16"></div>
          <p class="body bold">You can’t edit this form after you submit it.</p>
          <p class="body bold">Do you want to continue?</p>
          @if (formIsEmpty && submitClicked) {
            <section class="error mt-16">
              <i class="fa-light fa-circle-exclamation"></i>
              <p class="body" data-testid="vc-confirmation-empty-form-error">
                Please select an option or tell us about your needs.
              </p>
            </section>
          }
          <div class="button-container second-container">
            <app-button
              dataLabel="yes"
              [loading]="vm.isLoading"
              (click)="handleSubmit()"
              data-testid="vc-confirm-submit"
            >
              Yes
            </app-button>
            <app-button
              dataLabel="no"
              [buttonOptions]="{
                variant: 'secondary',
                disabled: vm.isLoading,
              }"
              (click)="goBack()"
            >
              No
            </app-button>
          </div>
        }
      </section>
    </section>
  }
} @else {
  @if (vm.error) {
    <section class="error-message" data-testid="vc-submission-error">
      <p class="body bold">Sorry, something went wrong</p>
      <p class="body">We’re having trouble with this form right now.</p>
      <p class="body">
        To let us know the extra support you need, please give us a call. We’re here to help and will treat your
        information with care.
      </p>
      <app-telephone-link [phoneNumber]="'0333 000 4966'" />
      <p class="hint">
        Calls cost the basic rate per minute plus your phone company’s access charge. From a mobile, they can cost much
        more. Calls to 0800 numbers are always free.
      </p>
    </section>
  } @else {
    <section class="submitted-message" data-testid="vc-submission-confirmed">
      <i class="fa-light fa-circle-check"></i>
      <p class="body">Thanks for letting us know your support needs.</p>
    </section>
  }
}
